var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.487 2.178a.75.75 0 0 0-.972 0l-8.25 7a.75.75 0 0 0-.088 1.056.75.75 0 0 0 1.056.088l.77-.65V15.5a2.5 2.5 0 0 0 2.5 2.5h9a2.5 2.5 0 0 0 2.5-2.5V9.672l.765.65a.749.749 0 1 0 .968-1.144zM4.501 15.5V8.4l5.5-4.666 5.5 4.666v7.1c0 .553-.447 1-1 1h-1.5v-4.75c0-.69-.56-1.25-1.25-1.25h-3.5c-.69 0-1.25.56-1.25 1.25v4.75h-1.5c-.553 0-1-.447-1-1m4 1V12h3v4.5z"
  })));
};
export default SvgHome;